var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.125 0 0 1.125 0 2.5V17.5C0 18.875 1.125 20 2.5 20H22.5C23.875 20 25 18.875 25 17.5V2.5C25 1.125 23.875 0 22.5 0ZM22 5.3125L13.825 10.425C13.0125 10.9375 11.9875 10.9375 11.175 10.425L3 5.3125C2.87466 5.24214 2.76489 5.14708 2.67736 5.03307C2.58982 4.91906 2.52632 4.78847 2.49072 4.64921C2.45511 4.50995 2.44813 4.36492 2.47019 4.22288C2.49226 4.08085 2.54292 3.94477 2.6191 3.82288C2.69528 3.70099 2.7954 3.59582 2.9134 3.51374C3.03141 3.43167 3.16483 3.37439 3.30561 3.34537C3.4464 3.31636 3.5916 3.31621 3.73244 3.34493C3.87328 3.37366 4.00682 3.43067 4.12499 3.5125L12.5 8.75L20.875 3.5125C20.9931 3.43067 21.1267 3.37366 21.2675 3.34493C21.4084 3.31621 21.5536 3.31636 21.6944 3.34537C21.8351 3.37439 21.9686 3.43167 22.0866 3.51374C22.2046 3.59582 22.3047 3.70099 22.3809 3.82288C22.457 3.94477 22.5077 4.08085 22.5298 4.22288C22.5518 4.36492 22.5449 4.50995 22.5093 4.64921C22.4736 4.78847 22.4101 4.91906 22.3226 5.03307C22.2351 5.14708 22.1253 5.24214 22 5.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/MessagesIcon.b4d9f6fc399f35e6053d47e2e99249d7.svg";
export { ForwardRef as ReactComponent };